import React from 'react';

import PropTypes from 'prop-types';
import BootstrapDropdown from 'react-bootstrap/Dropdown';

import { Loader } from '@src/components/ui';

const DropdownOptionsList = ({ isLoading, label, options, onOptionSelect }) => {
    const handleOptionClick = React.useCallback((event) => {
        const targetId = event.nativeEvent.target.id;
        onOptionSelect(targetId);
    }, [onOptionSelect]);

    if (isLoading) {
        return (
            <div className="select-options list-open">
                <Loader />
            </div>
        );
    }

    return (
        <BootstrapDropdown.Menu className="select-options list-open">
            <BootstrapDropdown.Item
                key="li-blank-option"
                eventKey=""
                tabIndex={-1}
                onClick={handleOptionClick}
            >
                { label }
            </BootstrapDropdown.Item>
            {
                options.map((item) => (
                    <BootstrapDropdown.Item
                        key={`li-${item.id}`}
                        id={item.id}
                        eventKey={item.id}
                        tabIndex={-1}
                        onClick={handleOptionClick}
                    >
                        { item.title }
                    </BootstrapDropdown.Item>
                ))
            }
        </BootstrapDropdown.Menu>
    );
};

DropdownOptionsList.propTypes = {
    isLoading: PropTypes.bool,
    label: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        title: PropTypes.string.isRequired,
    })).isRequired,
    onOptionSelect: PropTypes.func.isRequired,
};

export default React.memo(DropdownOptionsList);
